export class SetDictionary {
    words;
    constructor(words) {
        this.words = new Set();
        for (const w of words)
            this.words.add(w.toUpperCase());
    }
    isInDictionary(word) {
        return this.words.has(word.toUpperCase());
    }
    size() {
        return this.words.size;
    }
    *iterate() {
        yield* this.words;
    }
}
/**
 * Decode the len-prefixed-ascii-v1 binary from @scrabble-daily/dict into a SetDictionary.
 * Works in both Node (Buffer extends Uint8Array) and browser (raw Uint8Array from fetch).
 */
export function dictionaryFromBuffer(buf) {
    const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
    const count = view.getUint32(0, true);
    const decoder = new TextDecoder('ascii');
    const words = new Array(count);
    let offset = 4;
    for (let i = 0; i < count; i++) {
        const len = buf[offset++];
        words[i] = decoder.decode(buf.subarray(offset, offset + len));
        offset += len;
    }
    return new SetDictionary(words);
}
//# sourceMappingURL=dictionary.js.map